<template>
  <b-modal v-model="proModal" class="modals" :hideFooter="true" size="lg">
    <template #modal-header>
      <div class="position-relative w-100 d-flex align-items-center justify-content-center">
        <div class="dev-badge position-absolute" style="left: 0; top: 0; border-radius: 20px 0 10px 0;">
          <span class="font-weight-bold">{{ $t('pro.modalInDevelopment') }}</span>
        </div>
        
        <div class="text-center mx-auto mt-3">
          <img src="../../public/logo_pro.png" width="120px" alt="list2go logo" />
        </div>
        
        <button 
          type="button" 
          class="close position-absolute" 
          style="right: 3%; top: 50%; transform: translateY(-40%);" 
          @click="closeModal" 
          aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
    </template>
    <div class="modal-body">
      <p class="preis-font">{{ $t('pro.modalPrice') }}: <span class="font-weight-light">9,99€ {{ $t('pro.modalPerYear') }}</span></p>
      <div>
        <p>{{ $t('pro.modalManageListsAs') }}</p>
        <ul class="ul-pro ml-3">
          <li>
            🔒 {{ $t('pro.modalSecurity') }}
          </li>
          <li>
            🔄 {{ $t('pro.modalRecovery') }}
          </li>
          <li>
            👁️ {{ $t('pro.modalDashboard') }}
          </li>
          <li>
            <div>
              <p class="mb-0">{{ $t('pro.modalAndMore') }}</p>
              <p class="mb-0">🗒️ {{ $t('pro.modalAddDescriptions') }}</p>
              <p class="mb-0">🛠️ {{ $t('pro.modalRenameLists') }}</p>
            </div>
          </li>
        </ul>
      </div>

      <!-- Newsletter Anmeldung -->
      <div class="newsletter-container">
        <input
          type="email"
          v-model="email"
          :placeholder="$t('pro.modalEmailAddress')"
          class="newsletter-input"
        />
        <button @click="subscribe" :disabled="!email" class="newsletter-button">
          {{ $t('pro.modalNotifyMe') }}
        </button>
        <p v-if="successMessage" class="success-message">
          {{ $t('pro.modalSubscribeSuccess') }}
        </p>
      </div>
      <p class="font-weight-light text-center mt-2 my-0">
        {{ $t('pro.modalMoreIdeas') }}
      </p>
      <p class="font-weight-light text-center my-0">
        <a class="link" href="mailto:info@hartmann-bleeker.com"
          >info@hartmann-bleeker.com</a
        >
      </p>
      <p class="font-weight-light text-center my-0">{{ $t('pro.modalThankYou') }} 💙</p>
    </div>
  </b-modal>
</template>
  
<script>
export default {
	name: "ProModal",
	data() {
		return {
			proModal: false,
			email: "",
			successMessage: "",
		};
	},
	methods: {
		closeModal() {
			this.proModal = false;
		},
		async subscribe() {
			if (!this.email) return;

			const myHeaders = new Headers();
			myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

			const urlencoded = new URLSearchParams();
			urlencoded.append("email", this.email);

			const requestOptions = {
				method: "POST",
				headers: myHeaders,
				body: urlencoded,
				redirect: "follow",
			};

			try {
				const response = await fetch(
					"https://script.google.com/macros/s/AKfycbwnTCtD8gMPrAKyJrd3D0D8m6fknu4P9C6qmq3fWGudBm44KSqfxIgdD3jY4t4S3Afq0A/exec",
					requestOptions
				);
				const result = await response.text();
				console.log(result);
				this.successMessage = this.$t("pro.modalSubscribeSuccess"); // "Erfolgreich zum Newsletter angemeldet!";
			} catch (error) {
				console.error(error);
			}
		},
	},
};
</script>
  
  <style scoped>
.newsletter-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 20px;
}

::v-deep(.modal-content) {
  border-radius: 20px;
}

.close {
  font-size: 2rem;
  color: #7e7e7e;
}


::v-deep(.modal-header) {
  padding: 0rem;
  min-height: 70px;
  position: relative;
  z-index: 10;
}

.dev-badge {
  background-color: #fc6928;
  color: white;
  padding: 8px 15px;
  font-size: 0.8rem;
  margin-left: -0px;
  z-index: 5;
  border-top-left-radius: 0px; 
  border-bottom-right-radius: 20px; 
}

.dev-box {
  position: absolute;
  top: 0;
  right: 0;
  background-color: #fc6928;
  color: white;
  padding: 10px 10px;
  border-radius: 0 0 0 10px;
  font-size: 0.9rem;
  align-content: center;
  justify-content: center;
}

.newsletter-input {
  width: 50%;
  padding: 10px;
  margin-bottom: 10px;
  border: 1px solid #ccc;
  border-radius: 10px;
  text-align: center;
}

.newsletter-button {
  padding: 10px 10px;
  border: none;
  background-color: #28a745;
  color: white;
  border-radius: 10px;
  cursor: pointer;
}

.newsletter-button:disabled {
  background-color: #28a746;
  cursor: not-allowed;
}

.link {
  color: rgb(49, 49, 168);
}

.success-message {
  color: green;
  margin-top: 10px;
}
.ul-pro {
  padding-left: 0;
  margin-left: 0;
}

.preis-font {
  font-size: 1.2rem;
  font-weight: bold;
}

@media screen and (max-width: 576px) {
  .ul-pro {
    padding-left: 0;
    margin-left: 0;
  }
}
</style>
  